import gql from 'graphql-tag';
import ContentObject from './content_object';
import ContentReactions from './content_reactions';
import ContentDisclosures from './content_disclosures';
import PublicUserProfile from './public_user_profile';
import MinimalUserProfile from './minimal_user_profile';

export const Content = gql`
  fragment Content on Content {
    content_id
    content_source_id
    is_branded
    is_shareable
    is_important
    is_important_message
    is_engage
    is_shareable
    is_engageable
    is_pinned
    pinned_end_at
    important_to_share
    reaction_count
    comment_count
    share_count
    engagement_count
    reaction_count
    comment_count
    click_count
    publish_at
    group_ids
    has_requesting_user_shared
    lock_commentary
    pinned_to_groups {
      group_id
      pinned_end_at
    }
    commentary {
      network
      commentary
    }
    disclosures {
      ...ContentDisclosures
    }
    group_id_approvals {
      group_id
      approval
    }
    content_object {
      ...ContentObject
    }
    reactions {
      ...ContentReactions
    }
    groups {
      id
      title
    }
    group_ids
    user {
      ...PublicUserProfile
    }
    url_param_values {
      key
      value
    }
    reacted_by {
      ...MinimalUserProfile
    }
    shared_by {
      ...MinimalUserProfile
    }
    commented_by {
      ...MinimalUserProfile
    }
    schedule {
      publish
      expire
    }
  }
  ${ContentDisclosures}
  ${ContentObject}
  ${ContentReactions}
  ${PublicUserProfile}
  ${MinimalUserProfile}
`;

export const ContentShare = gql`
  fragment ContentShare on Content {
    content_id
    share_count
    engagement_count
    reaction_count
    comment_count
    click_count
    publish_at
    has_requesting_user_shared
    commentary {
      network
      commentary
    }
    groups {
      id
      title
    }
    content_object {
      ...ContentObject
    }
  }
  ${ContentObject}
`;
